module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/177-colombia-bdd5ad56c08b67eb0b54c0325546f939.svg";